import produce from "immer";
import { each } from "lodash";
import { useInjection } from "@linkfluence/core/di";
import { User } from "@linkfluence/models/user";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserRepo, UserRepositoryUID } from "../repositories/UserRepo";
import { useCurrentUser } from "./useCurrentUser";

function mergeUserData(reference: User, update: Partial<User>) {
  return produce(reference, (draft) => {
    each(update, (value, key) => {
      draft[key] = value;
    });
  });
}

export function useUpdateCurrentUser(optimistic = false) {
  const queryClient = useQueryClient();
  const repository = useInjection<UserRepo>(UserRepositoryUID);
  const currentUser = useCurrentUser();
  const updateQueryData = (data) => {
    queryClient.setQueryData(
      ["/user/current"],
      mergeUserData(currentUser, data)
    );
  };
  const { mutateAsync } = useMutation(
    (user: Partial<User>) => {
      if (optimistic) {
        updateQueryData(user);
      }

      return repository.updateCurrentUser(
        currentUser.id,
        mergeUserData(currentUser, user)
      );
    },
    {
      onSuccess: (_, user) => {
        updateQueryData(user);
      },
    }
  );
  return mutateAsync;
}
